module.exports = __webpack_public_path__ + "img/ico_unRateStar.c60a2ec4.png";